import React from "react";
import Button from "../Forms/Button";

// Boutons prédéfinis
export const SaveButton = ({ onClick, disabled }) => (
  <Button variant="green" onClick={onClick} disabled={disabled}>
    Enregistrer
  </Button>
);

export const CancelButton = ({ onClick, disabled }) => (
  <Button variant="grey" onClick={onClick} disabled={disabled}>
    Annuler
  </Button>
);

export const DeleteButton = ({ onClick, disabled }) => (
  <Button variant="red" onClick={onClick} disabled={disabled}>
    Supprimer
  </Button>
);

export const ValidateButton = ({ onClick, disabled }) => (
  <Button variant="blue" onClick={onClick} disabled={disabled}>
    Valider
  </Button>
);

export const DisabledButton = () => (
  <Button variant="disabled" disabled>
    Désactivé
  </Button>
);
